interface Props {
  children: React.ReactNode;
}

const PageInnerContent = ({ children }: Props) => (
  <div className="inner-content">
    {children}

    <style jsx>{`
      .inner-content {
        display: block;
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 1;
        min-width: 0;
      }
    `}</style>
  </div>
);

export default PageInnerContent;
